import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import { Icons } from '@/icons/icons'
import { vars } from '@/styles/styleVars'
import { Status as FileStatus, File } from './types/LfProgressBarTypes'

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'LfProgressBarComponent',
  props: {
  file: {
    type: Object as PropType<File>,
    required: true
  },
  keyName: {
    type: String,
    default: 'name'
  }
},
  setup(__props) {

const props = __props;



// TRANSLATIONS
const { t } = useI18n()

const texts = {
  errorText: t('components.progress_bar.error_text'),
  loadingText: t('components.progress_bar.loading_text'),
  successText: t('components.progress_bar.success_text')
}

// COMPUTED
const computedFileName = computed(() => props.file[props.keyName as keyof File])

const computedInfoText = computed(() => {
  switch (props.file.status) {
    case FileStatus.LOADED:
      return texts.successText
    default:
      return texts.loadingText
  }
})

const computedInfoIcon = computed(() => {
  switch (props.file.status) {
    case FileStatus.LOADED:
      return Icons.CHECK_ROUND_FULL
    case FileStatus.ERROR:
      return Icons.CLOSE_ROUND_FULL
    default:
      return Icons.SPINNER
  }
})

const computedIndeterminate = computed(() => props.file.status === FileStatus.LOADING)

const computedBackgroundColor = computed(() => {
  switch (props.file.status) {
    case FileStatus.LOADED:
      return vars.progress_bar_success
    case FileStatus.ERROR:
      return vars.progress_bar_error
    default:
      return vars.progress_bar_default_color
  }
})

const computedErrorText = computed(() => props.file.status === FileStatus.ERROR)

return { __sfc: true,props, t, texts, computedFileName, computedInfoText, computedInfoIcon, computedIndeterminate, computedBackgroundColor, computedErrorText, vars }
}

})